import { Provider } from 'react-redux'
import { store } from '../redux'

export const withRedux = (component: () => React.ReactNode) => () => {
  return <Provider store={store}>{component()}</Provider>
}
